import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ListItemText, MenuItem, Select } from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";

import { setBreadcrumb } from "../../actions/common";
import { roles } from "../../constants/roles";
import { fetchGet, fetchPost } from "../../api/fetch";
import css from "./ProductSearch.module.css";
import ScanPopup from "./ScanPopup"
import ProductLookupDialogRow from "./ProductLookupDialogRow";
import noImageProduct from './assets/no_name_product.svg';
import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';
import Barcode from './assets/mdi_barcode_scan.svg';
import BackArrow from './assets/back_arrow.svg';
import SearchIcon from './assets/search_icon_grey.png';
import { calcProductState } from "../VMI/ProductUtil";
import ProductLookupTableRow from "./ProductLookupTableRow";

const styles = {
  mainLookup: {
    display: "flex",
    '@media(max-width: 470px)': {
      height: "100%",
    }
  },
  mainContent: {
    minHeight: 0,
    margin: "24px 24px 0 24px",
    padding: "24px",
    width: "calc(100vw - 128px)",
    maxWidth: "calc(100vw - 128px)",
    height: "calc(100vh - 140px)",
    '@media(max-width: 470px)': {
      margin: "0",
      padding: "0px",
      borderRadius: "0",
      width: "100%",
      height: "calc(100vh - 100px)",
      maxWidth: "none",
      overflow: "hidden",
    }
  },
  searchBar: {
    minHeight: 0,
    margin: "24px 0 0 0px",
    padding: "24px",
    borderRadius: "0px 4px 4px 0px",
    width: "276px",
    height: "calc(100vh - 140px)",
    '@media(max-width: 470px)': {
      margin: "0",
      padding: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    }
  },
  noDisplay: {
    display: "none",
  },
  searchPopupMain: {
    '@media(max-width: 470px)': {
      height: "100%",
    }
  },
  interactPanel: {
    '@media(max-width: 470px)': {
      width: "100%",
    }
  },
  controlPanel: {
    marginLeft: "8px",
    marginTop: "8px",
    marginBottom: "16px",
  },
  searchInput: {
    width: "244px",
    height: "36px",
    marginBottom: "16px",
    fontSize: "14px",
    "&::placeholder": {
      fontStyle: "italic",
    },
    '@media(max-width: 470px)': {
      width: "290px",
    }
  },
  btnPanel: {
    '@media(max-width: 470px)': {
      boxSizing: "border-box",
      margin: "0",
      height: "50px",
      minHeight: "50px"
    }
  },
  confirmBtn: {
    '@media(max-width: 470px)': {
      alignSelf: "center",
    }
  },
  mobileScroll: {
    '@media(max-width: 470px)': {
      overflowY: "auto",
      paddingLeft: "16px",
      width: "340px",
    }
  },
  scanProduct: {
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
    width: "48px",
    padding: "12px 0px 12px 0px",
    margin: "0px 12px 0px 12px",
    '@media(max-width: 470px)': {
      width: "auto",
      height: "48px",
      padding: "0px 0px 0px 4px",
      margin: "0px 0px 0px 0px",
    }
  },
  tableMain: {
    height: "100%",
    maxWidth: "1396px",
    '@media(max-width: 470px)': {
      display: "flex",
      flexDirection: "column"
    }
  },
  tableControl: {
    width: "100%",
    '@media(max-width: 470px)': {
      color: "rgba(0, 0, 0, 0.54)",
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid #dddddd",
      justifyContent: "space-between",
    }
  },
  tableContainer: {
    width: "100%",
    height: "calc(100% - 20.016px - 42px)",
    overflow: "auto",
    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },
    "& table thead tr": {
      backgroundColor: "white",
      height: "50px"
    },
    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },
    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",
      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },
    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
  },
  tableAdmin: {
    width: "calc(110px + 440px + 135px + 200px + 110px + 110px + 135px + 400px + 120px + 150px + 200px + 120px)",
  },
  tableClient: {
    width: "calc(440px + 135px + 200px + 110px + 110px + 135px + 400px + 120px + 150px )",
  },
  evenRow: {
    backgroundColor: "#f8f8f8",
  },
  // TABLE COLUMNS
  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  tableCompany: {
    width: "110px",
  },
  tableDescription: {
    width: "440px",
  },
  tableManufacturerCode: {
    width: "135px",
  },
  tablePendingOrder: {
    width: "200px",
  },
  tableSite: {
    width: "110px",
  },
  tableSector: {
    width: "110px",
  },
  tableBinCode: {
    width: "135px",
  },
  tableLocation: {
    width: "400px",
  },
  tableCategory: {
    width: "120px",
  },
  tableManufacturer: {
    width: "150px",
  },
  tableVendorName: {
    width: "200px",
  },
  tableJrvCode: {
    width: "120px",
  },
  // TABLE BODY
  cellEllipse: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  textRed: {
    color: "#eb3c39"
  },
  textBold: {
    fontWeight: "500"
  },
  sortContainer: {
    marginLeft: "4px",
    cursor: "pointer",
  },
  dropdownInverted: {
    transform: "rotate(180deg)",
  },
  // DIALOG
  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "360px",
    margin: 0,
  },
  lookupDialog: {
    width: "1011px",
    height: "695px",
    margin: "24px",
    '@media(max-width: 470px)': {
      margin: "0px",
      width: "100%",
      maxWidth: "360px",
      height: "640px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: "1px solid #dddddd",
    },
  },
  dialogNav: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    '@media(max-width: 470px)': {
      width: "100%",
      height: "24px",
      display: "grid",
      gridTemplateColumns: "1fr 24px",
      marginBottom: "30px",
      fontSize: "16px",
      boxSizing: "border-box",
      padding: "16px"
    }
  },
  productTitle: {
    fontSize: "16px",
    fontWeight: "500",
    '@media(max-width: 470px)': {
      width: "100%",
      textAlign: "left",
    }
  },
  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    },
    '@media(max-width: 470px)': {
      alignSelf: "start"
    }
  },
  dialogMain: {
    width: "100%",
    height: "calc(100% - 24px - 20px)",
    display: "flex",
    justifyContent: "space-between",
    '@media(max-width: 470px)': {
      flexDirection: "column",
    }
  },
  productInfo: {
    height: "100%",
    width: "233px",
    marginRight: "18px",
    display: "flex",
    flexDirection: "column",
    '@media(max-width: 470px)': {
      width: "100%",
      height: "auto"
    }
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
    width: "100%"
  },
  dialogSubtitle: {
    marginBottom: "4px",
    '@media(max-width: 470px)': {
      width: "100%",
      textAlign: "center",
      marginTop: "4px",
    }
  },
  text38: {
    color: "rgba(0, 0, 0, 0.38)",
  },
  productDetails: {
    width: "100%",
    height: "100%",
    backgroundColor: "#f8f8f8",
    border: "1px solid #dddddd",
    borderRadius: "2px",
    padding: "8px",
    '@media(max-width: 470px)': {
      display: "grid",
      gridTemplateColumns: "50% 50%",
      gridTemplateRows: "50px 50px 50px 50px",
      backgroundColor: "white",
      height: "auto",
      border: "none",
      borderBottom: "1px solid #dddddd",
      borderRadius: "0",
    }
  },
  itemPicture: {
    maxWidth: "100px",
    maxHeight: "70px",
  },
  detailItem: {
    display: "flex",
    flexDirection: "column",
    marginTop: "24px",
    '@media(max-width: 470px)': {
      marginTop: "0",
    }
  },
  detailSubtitle: {
    fontWeight: "500",
  },
  productPlacement: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  locationDetails: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    '@media(max-width: 470px)': {
      padding: "0px 8px",
    }
  },
  //Pagination
  paginationSection: {
    height: "42px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    '@media(max-width: 470px)': {
      height: "50px",
    }
  },
  paginationMain: {
    height: "100%",
    display: "flex",
    alignItems: "flex-end",
    '@media(max-width: 470px)': {
      flexDirection: "column",
      alignItems: "center",
    }
  },
  paginationLimit: {
    display: "flex",
    alignItems: "flex-end",
  },
  paginationDropdown: {
    marginLeft: "4px",
    marginRight: "16px",
    fontSize: "14px",
    "& > .MuiSelect-select": {
      paddingBottom: "0px"
    },
    "& > .MuiSelect-icon": {
      top: "calc(50% - 11px)"
    }
  },
  countDisplay: {
    width: "120px",
    textAlign: "right",
    '@media(max-width: 470px)': {
      width: "200px",
      fontSize: "12px",
      textAlign: "center",
    }
  },
  pageControl: {
    marginLeft: "40px",
    display: "flex",
    alignItems: "flex-end",
    '@media(max-width: 470px)': {
      width: "340px",
      margin: "0",
      justifyContent: "space-between",
      alignItems: "center",
    }
  },
  pageDisplay: {
    border: "1px solid #757575",
    borderRadius: "2px",
    width: "40px",
    height: "24px",
    boxSizing: "border-box",
    paddingTop: "1px",
    textAlign: "center",
    userSelect: "none",
    '@media(max-width: 470px)': {
      border: "none",
      fontSize: "18px",
      color: "#5f00a0",
      fontWeight: "500",
      paddingTop: "0",
    }
  },
  offsetControl: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    display: "grid",
    placeItems: "center",
  },
  // Dropdown Select
  dropdownSelect: {
    height: "36px",
    width: "244px",
    marginBottom: "16px",
    border: "1px solid rgba(0,0,0,0.23)",
    borderRadius: "2px",
    paddingLeft: "8px",
    "&::before": {
      border: "none"
    },
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
    '@media(max-width: 470px)': {
      width: "290px",
    }
  },
  select: {
    "& ul li div span": {
      fontSize: "14px",

    }
  }

}

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const ProductLookup = (props) => {
  const { classes, dispatch, language } = props;

  // Product Search
  const [company, setCompany] = React.useState(0)
  const [description, setDescription] = React.useState("")
  const [manufacturerCode, setManufacturerCode] = React.useState("")
  const [manufacturer, setManufacturer] = React.useState("")
  const [vendorName, setVendorName] = React.useState("")
  const [jrvCode, setJrvCode] = React.useState("")
  const [category, setCategory] = React.useState("")
  const [binCode, setBinCode] = React.useState("")

  // Pagination
  const [searchResults, setSearchResults] = React.useState([])
  const [searchTotal, setSearchTotal] = React.useState(0)
  const [searchLimit, setSearchLimit] = React.useState(100)
  const [searchOffset, setSearchOffset] = React.useState(0)
  const [pagesQuantity, setPagesQuantity] = React.useState(0)

  // Sort
  const [sortDescription, setSortDescription] = React.useState(false)
  const [sortManufacturerCode, setSortManufacturerCode] = React.useState(false)

  const [sortCompany, setSortCompany] = React.useState(false)
  const [sortSite, setSortSite] = React.useState(false)
  const [sortSector, setSortSector] = React.useState(false)
  const [sortBinCode, setSortBinCode] = React.useState(false)
  const [sortLocation, setSortLocation] = React.useState(false)
  const [sortCategory, setSortCategory] = React.useState(false)
  const [sortManufacturer, setSortManufacturer] = React.useState(false)
  const [sortVendorName, setSortVendorName] = React.useState(false)
  const [sortJrvCode, setSortJrvCode] = React.useState(false)

  // Fetch
  const [isFetching, setIsFetching] = React.useState(false)

  // Scan Dialog
  const [scanDialog, setOpenScan] = React.useState(false)

  // Scan Error
  const [scanError, setScanError] = React.useState("")

  // Dialog Logic
  const [lookupDialog, setLookupDialog] = React.useState(false)
  const [activeProductData, setActiveProductData] = React.useState({})
  const [showDetails, setShowDetails] = React.useState(true)

  // Mobile Display Logic
  const [currentView, setCurrentView] = React.useState("search") // "search" | "table"

  // Dropdown Companies
  const [dropdownCompanies, setDropdownCompanies] = React.useState([])

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: I18n.get("sidebar_lookup"),
        },
      ])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    try {
      fetchGet(`/vmi/companies/sectors/vmi`)
        .then(companies => {
          setDropdownCompanies(companies)
        })
        .catch(e => console.error(e))

    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // SORT LOGIC
  React.useEffect(() => {
    sortCompany ? setSearchResults(searchResults.sort((a, b) => a.company_name.localeCompare(b.company_name, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.company_name.localeCompare(a.company_name, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortCompany]);
  React.useEffect(() => {
    sortDescription ? setSearchResults(searchResults.sort((a, b) => a.description_en.localeCompare(b.description_en, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.description_en.localeCompare(a.description_en, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortDescription])
  React.useEffect(() => {
    !sortManufacturerCode ? setSearchResults(searchResults.sort((a, b) => a.manufacturer_item_code.localeCompare(b.manufacturer_item_code, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.manufacturer_item_code.localeCompare(a.manufacturer_item_code, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortManufacturerCode])
  React.useEffect(() => {
    sortSite ? setSearchResults(searchResults.sort((a, b) => a.site_name.localeCompare(b.site_name, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.site_name.localeCompare(a.site_name, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortSite])
  React.useEffect(() => {
    sortSector ? setSearchResults(searchResults.sort((a, b) => a.sector_name.localeCompare(b.sector_name, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.sector_name.localeCompare(a.sector_name, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortSector])
  React.useEffect(() => {
    sortLocation ? setSearchResults(searchResults.sort((a, b) => a.assigned[0].localeCompare(b.assigned[0], 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.assigned[0].localeCompare(a.assigned[0], 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortLocation])
  React.useEffect(() => {
    sortCategory ? setSearchResults(searchResults.sort((a, b) => a.category.localeCompare(b.category, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.category.localeCompare(a.category, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortCategory])
  React.useEffect(() => {
    sortManufacturer ? setSearchResults(searchResults.sort((a, b) => a.manufacturer_name.localeCompare(b.manufacturer_name, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.manufacturer_name.localeCompare(a.manufacturer_name, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortManufacturer])
  React.useEffect(() => {
    sortVendorName ? setSearchResults(searchResults.sort((a, b) => a.vendor_name.localeCompare(b.vendor_name, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.vendor_name.localeCompare(a.vendor_name, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortVendorName])
  React.useEffect(() => {
    !sortBinCode ? setSearchResults(searchResults.sort((a, b) => b.pzi_id - a.pzi_id)) : setSearchResults(searchResults.sort((a, b) => a.pzi_id - b.pzi_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBinCode])
  React.useEffect(() => {
    sortJrvCode ? setSearchResults(searchResults.sort((a, b) => a.jrv_code.localeCompare(b.jrv_code, 'en', { sensitivity: 'base' }))) : setSearchResults(searchResults.sort((a, b) => b.jrv_code.localeCompare(a.jrv_code, 'en', { sensitivity: 'base' })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortJrvCode])

  const handleSearchProduct = sortParameters => { // SEARCH BUTTON
    setSearchResults([])
    const body = {
      "description": description ? description.trim() : null,
      "code_product": null,
      "vendor_name": vendorName ? vendorName.trim() : null,
      "manufacturer_name": manufacturer ? manufacturer.trim() : null,
      "manufacturer_code": manufacturerCode ? manufacturerCode.trim() : null,
      "ogc": null,
      "category": category ? category.trim() : null,
      "limit": searchLimit,
      "vmi": null,
      "codebin": binCode ? parseInt(binCode.trim()) : null,
      "jrv_code": jrvCode ? jrvCode.trim() : null,
      "offset": 0,
      "sort": sortParameters ? sortParameters : null,
      "version": 2,
      "company": company ? company : null,
    }

    try {
      setIsFetching(true)
      fetchPost("products/search", body)
        .then(res => {
          setSearchResults(res.items)
          setSearchTotal(res.total)

          if (res.total > res.items.length) {
            setPagesQuantity(Math.ceil(res.total / searchLimit))
          } else if (res.items.length > 1) {
            setPagesQuantity(1)
          }
          setIsFetching(false)

          if (getWidth() < 470) {
            setCurrentView("table")
          }
          // product not found!?
        })
        .catch(e => {
          setIsFetching(false)
          console.error(e)
        })
    } catch (e) {
      console.log(e);
    }
  }

  const handleOffset = type => {
    let _offset = searchOffset;

    if (type === "plus") {
      if (_offset === ((pagesQuantity - 1) * searchLimit)) {
        return
      } else {
        setSearchOffset(searchOffset + searchLimit)
        _offset += searchLimit;
      }
    } else if (type === "minus") {
      if (_offset === 0) {
        return
      } else {
        setSearchOffset(searchOffset - searchLimit)
        _offset -= searchLimit;
      }
    } else if (type === "min") {
      setSearchOffset(0)
      _offset = 0;
    } else if (type === "max") {
      setSearchOffset((pagesQuantity - 1) * searchLimit)
      _offset = (pagesQuantity - 1) * searchLimit
    }

    const body = {
      "description": description ? description.trim() : null,
      "code_product": null,
      "vendor_name": vendorName ? vendorName.trim() : null,
      "manufacturer_name": manufacturer ? manufacturer.trim() : null,
      "manufacturer_code": manufacturerCode ? manufacturerCode.trim() : null,
      "ogc": null,
      "category": category ? category.trim() : null,
      "limit": searchLimit,
      "vmi": null,
      "codebin": binCode ? parseInt(binCode.trim()) : null,
      "jrv_code": jrvCode ? jrvCode.trim() : null,
      "offset": _offset,
      "sort": null,
      "version": 2,
      "company": company ? company : null,
    }

    try {
      setIsFetching(true)
      fetchPost("products/search", body)
        .then(res => {
          setSearchResults(res.items)
          setIsFetching(false)

          // product not found!?
        })
        .catch(e => {
          setIsFetching(false)

          console.error(e)
        })
    } catch (e) {
      console.log(e);
    }
  }

  const handleLookupDialog = (pid, productData, pzi_id) => {
    try {
      fetchGet(`/product_zone_inventory/locations/${pid}`)
        .then(locationData => {
          console.log(locationData)
          console.log(pzi_id)
          console.log({ productData, locationData })
          // 10034834
          setActiveProductData({ productData, locationData })
          setLookupDialog(true)
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
  }

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      handleSearchProduct()
    }
  }

  const handleResetFields = () => {
    // Search Queries
    setCompany(0)
    setDescription("")
    setManufacturerCode("")
    setManufacturer("")
    setVendorName("")
    setJrvCode("")
    setCategory("")
    setBinCode("")
    // Sort Filters
    setSortCompany(false)
    setSortDescription(false)
    setSortManufacturerCode(false)
    setSortSite(false)
    setSortSector(false)
    setSortBinCode(false)
    setSortLocation(false)
    setSortCategory(false)
    setSortManufacturer(false)
    setSortVendorName(false)
    setSortJrvCode(false)
  }

  const handleLimitChange = (event) => {
    setSearchLimit(event.target.value);
    setSearchResults([])
    setSearchTotal(0)
    setSearchOffset(0)
    setPagesQuantity(0)
  };

  const handleSelection = event => {
    setCompany(event.target.value);
  };

  const handleScanDialog = scanId => {
    if (scanId > 100000) { // Scan PZI ID - Order Request Dialog
      const body = {
        "description": null,
        "code_product": null,
        "vendor_name": null,
        "manufacturer_name": null,
        "manufacturer_code": null,
        "ogc": null,
        "category": null,
        "limit": searchLimit,
        "vmi": null,
        "codebin": scanId,
        "jrv_code": null,
        "offset": 0,
        "sort": null,
        "version": 2,
        "company": null,
      }

      try {
        setIsFetching(true)
        fetchPost("products/search", body)
          .then(res => {
            setSearchResults(res.items)
            setIsFetching(false)
            setSearchTotal(res.total)

            if (res.total > res.items.length) {
              setPagesQuantity(Math.ceil(res.total / searchLimit))
            }
            setIsFetching(false)

            if (getWidth() < 470) {
              setCurrentView("table")
            }
            // product not found!?
          })
          .catch(e => {
            setIsFetching(false)
            console.error(e)
          })
      } catch (e) {
        console.log(e);
      }

      setBinCode(scanId.toString())
      setOpenScan(false)
    } else { //Scan Zone ID - Zone Navigation Dialog
      setOpenScan(false)
    }
  }

  const level = get(props, ["userRole", "level"]);

  return (
    <div className={classes.mainLookup}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={`mainContent ${classes.searchBar} ${getWidth() < 470 && currentView === "table" ? classes.noDisplay : ""}`}
      >
        <Grid item style={{ height: "100%" }}>
          <div className={`${css.searchPopupMain} ${classes.searchPopupMain}`}>
            <div className={`${css.interactPanel} ${classes.interactPanel}`}>
              <div className={`${css.controlPanel} ${classes.controlPanel}`}>
                <Dialog
                  open={scanDialog}
                  PaperProps={{
                    style: {
                      margin: "0"
                    },
                  }}
                  onBackdropClick={() => setOpenScan(false)}>
                  <ScanPopup
                    setOpenScan={setOpenScan}
                    errorMsg={scanError}
                    setScanError={setScanError}
                    handleScanDialog={handleScanDialog}
                  />
                </Dialog>
                <div className={classes.scanProduct} onClick={() => setOpenScan(true)}>
                  <img src={Barcode} alt="Scan Product" />
                </div>
              </div>
              <span className={classes.mobileScroll}>
                {level <= roles.customerAdmin ?
                  <>
                    <div className={css.inputSubtitle}>{I18n.get("site_company")}</div>
                    <Select
                      value={company}
                      onChange={handleSelection}
                      MenuProps={{
                        getContentAnchorEl: null,
                        PaperProps: {
                          style: {
                            maxHeight: getWidth() > 478 ? 360 : 540,
                            width: getWidth() > 478 ? 244 : 190,
                          },
                        },
                        classes: { paper: classes.select }
                      }}
                      className={classes.dropdownSelect}
                      disableUnderline={true}
                    >
                      <MenuItem key={`company-None`} value={0} >
                        <ListItemText primary={"None"} />
                      </MenuItem>
                      {dropdownCompanies.map((c, i) =>
                        <MenuItem key={`company-${i}`} value={c.id} >
                          <ListItemText primary={c.name} />
                        </MenuItem>)}
                    </Select>
                  </>
                  : null}
                <div className={css.inputSubtitle}>{I18n.get("site_description")}</div>
                <TextField
                  value={description}
                  placeholder={I18n.get("site_description")}
                  onChange={e => setDescription(e.target.value)}
                  onKeyDown={handleKeyDown}

                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: description ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setDescription("")}><Close /></InputAdornment> : null,
                    className: classes.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("manufacturer_item_code")}</div>
                <TextField
                  value={manufacturerCode}
                  placeholder={I18n.get("manufacturer_item_code")}
                  onChange={e => setManufacturerCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: manufacturerCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturerCode("")}><Close /></InputAdornment> : null,
                    className: classes.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("manufacturer")}</div>
                <TextField
                  value={manufacturer}
                  placeholder={I18n.get("manufacturer")}
                  onChange={e => setManufacturer(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: manufacturer ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setManufacturer("")}><Close /></InputAdornment> : null,
                    className: classes.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                {level <= roles.customerAdmin ?
                  <>
                    <div className={css.inputSubtitle}>{I18n.get("vendor_name")}</div>
                    <TextField
                      value={vendorName}
                      placeholder={I18n.get("vendor_name")}
                      onChange={e => setVendorName(e.target.value)}
                      onKeyDown={handleKeyDown}
                      variant="outlined"
                      InputProps={{
                        startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                        endAdornment: vendorName ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setVendorName("")}><Close /></InputAdornment> : null,
                        className: classes.searchInput,
                        style: { fontSize: 14, padding: "0 0 0 8px" }
                      }}
                    />
                  </>
                  : null}
                {level <= roles.customerAdmin ?
                  <>
                    <div className={css.inputSubtitle}>{I18n.get("jrv_code")}</div>
                    <TextField
                      value={jrvCode}
                      placeholder={I18n.get("jrv_code")}
                      onChange={e => setJrvCode(e.target.value)}
                      onKeyDown={handleKeyDown}
                      variant="outlined"
                      InputProps={{
                        startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                        endAdornment: jrvCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setJrvCode("")}><Close /></InputAdornment> : null,
                        className: classes.searchInput,
                        style: { fontSize: 14, padding: "0 0 0 8px" }
                      }}
                    />
                  </>
                  : null}
                <div className={css.inputSubtitle}>{I18n.get("category")}</div>
                <TextField
                  value={category}
                  placeholder={I18n.get("category")}
                  onChange={e => setCategory(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: category ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setCategory("")}><Close /></InputAdornment> : null,
                    className: classes.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
                <div className={css.inputSubtitle}>{I18n.get("code_bin")}</div>
                <TextField
                  value={binCode}
                  placeholder={I18n.get("code_bin")}
                  onChange={e => setBinCode(e.target.value)}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
                    endAdornment: binCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setBinCode("")}><Close /></InputAdornment> : null,
                    className: classes.searchInput,
                    style: { fontSize: 14, padding: "0 0 0 8px" }
                  }}
                />
              </span>
              <div className={`${css.btnPanel} ${classes.btnPanel}`}>
                <div className={css.blueText} onClick={() => handleResetFields()}>{I18n.get("reset_fields")}</div>
                <button className={`${css.confirmBtn} ${classes.confirmBtn}`} onClick={() => handleSearchProduct()}>{!isFetching ? I18n.get("site_search").toUpperCase() : <CircularProgress size={16} style={{ 'color': 'white' }} />}</button>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={`mainContent ${classes.mainContent} ${getWidth() < 470 && currentView === "search" ? classes.noDisplay : ""}`}
      >
        <Grid item className={`${classes.tableMain}`}>
          <Dialog
            maxWidth={false}
            open={lookupDialog}
            classes={getWidth() < 470 ? { paper: classes.dialogPaper } : {}}
            PaperProps={{ style: { margin: "0" }, }}
            onBackdropClick={() => setLookupDialog(false)}
          >
            <div className={classes.lookupDialog}>
              <div className={classes.dialogNav}>
                <div className={classes.productTitle}>{activeProductData.productData ? (language === "en" ? activeProductData.productData.description_en : activeProductData.productData.description_fr) : "-"}</div>
                <div className={classes.closeButton}>
                  <Close onClick={() => { setLookupDialog(false) }} />
                </div>
              </div>
              <div className={classes.dialogMain}>
                <div className={classes.productInfo}>
                  {getWidth() > 470 ?
                    <div className={`${classes.dialogSubtitle} ${classes.text38}`}>{I18n.get("site_product")}</div>
                    :
                    <div className={classes.headerControl} onClick={() => setShowDetails(!showDetails)}>
                      <img src={showDetails ? DropdownDown : DropdownRight} alt="Dropdown" />
                      <div style={{ marginLeft: "4px" }}>{I18n.get("site_details")}</div>
                    </div>}
                  {showDetails ?
                    <div className={classes.productDetails}>
                      <div className={classes.itemPicture}>
                        <img
                          src={noImageProduct}
                          alt="Product"
                        />
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("product_state_active")}
                        </div>
                        <div>{activeProductData.productData ? calcProductState(activeProductData.productData['blocked'], activeProductData.productData['deleted'], activeProductData.productData['obsolete']) : "-"}</div>
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("manu_name")}
                        </div>
                        <div>{activeProductData.productData && activeProductData.productData.manufacturer_name !== "" ? activeProductData.productData.manufacturer_name : "-"}</div>
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("manu_code")}
                        </div>
                        <div>-</div>
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("manu_item_code")}
                        </div>
                        <div>{activeProductData.productData && activeProductData.productData.manufacturer_item_code !== " " && activeProductData.productData.manufacturer_item_code !== "" ? activeProductData.productData.manufacturer_item_code : "-"}</div>
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("category")}
                        </div>
                        <div>{activeProductData.productData ? activeProductData.productData.category : "-"}</div>
                      </div>
                      <div className={classes.detailItem}>
                        <div className={classes.detailSubtitle}>
                          {I18n.get("unit_weight")}
                        </div>
                        <div>{activeProductData.productData && activeProductData.productData.weight_unit ? activeProductData.productData.weight_unit : "-"}</div>
                      </div>
                    </div>
                    :
                    null}
                </div>
                <div className={classes.productPlacement}>
                  <div className={`${classes.dialogSubtitle} ${getWidth > 470 ? classes.text38 : ""}`}>{I18n.get("location_vmi")} ({activeProductData.locationData ? activeProductData.locationData.length : 0})</div>
                  <div className={classes.locationDetails}>
                    {activeProductData.locationData ? [...activeProductData.locationData.filter(p => p.pzi_id === activeProductData.productData.pzi_id), ...activeProductData.locationData.filter(p => p.pzi_id !== activeProductData.productData.pzi_id)].map((ld, i) => <ProductLookupDialogRow locationData={ld} i={i} />) : null}
                  </div>
                </div>
              </div>
            </div>
          </Dialog>
          <div className={classes.tableControl}>
            {getWidth() < 470 ?
              <span>
                <div className={classes.scanProduct} onClick={() => setCurrentView("search")}>
                  <img src={BackArrow} alt="Scan Product" />
                </div>
                <div style={{ width: "24px", height: "24px", boxSizing: "border-box", padding: "2px" }} className={classes.scanProduct} onClick={() => setCurrentView("search")}>
                  <img style={{ width: "100%", height: "100%" }} src={SearchIcon} alt="Scan Product" />
                </div>
              </span>
              : null
            }
            <span>{getWidth() > 470 ? `${I18n.get("site_results")}${language === "en" ? ":" : " :"} ${searchTotal}` : `${searchTotal} ${I18n.get("site_results")}`}</span>
            {getWidth() < 470 ?
              <span style={{ display: "flex", paddingRight: "4px" }}>
                <div style={{ width: "24px", height: "24px" }}></div>
                <div style={{ width: "24px", height: "24px" }}></div>
              </span>
              : null}
          </div>
          {/* TABLE HEADER */}
          <div className={classes.tableContainer}>
            {getWidth() > 470 ?
              <table className={level <= roles.customerAdmin ? classes.tableAdmin : classes.tableClient}>
                <thead>
                  <tr>
                    {level <= roles.customerAdmin ?
                      <th className={classes.tableCompany}>
                        <div className={classes.tableSubtitle}>
                          <div>
                            {I18n.get("companies_company")}
                          </div>
                          <div className={classes.sortContainer} onClick={() => setSortCompany(!sortCompany)}>
                            {!sortCompany ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                          </div>
                        </div>
                      </th> : null}
                    <th className={classes.tableDescription}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("site_description")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortDescription(!sortDescription)}>
                          {!sortDescription ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableManufacturerCode}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("manufacturer_item_code")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortManufacturerCode(!sortManufacturerCode)}>
                          {!sortManufacturerCode ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tablePendingOrder}>
                      <div className={classes.tableSubtitle}>
                        {I18n.get("pending_order")}
                      </div>
                    </th>
                    <th className={classes.tableSite}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("companies_site")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortSite(!sortSite)}>
                          {!sortSite ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableSector}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("sector")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortSector(!sortSector)}>
                          {!sortSector ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableBinCode}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("code_bin")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortBinCode(!sortBinCode)}>
                          {!sortBinCode ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableLocation}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("location_vmi")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortLocation(!sortLocation)}>
                          {!sortLocation ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableCategory}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("category")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortCategory(!sortCategory)}>
                          {!sortCategory ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    <th className={classes.tableManufacturer}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("manufacturer")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortManufacturer(!sortManufacturer)}>
                          {!sortManufacturer ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th>
                    {level <= roles.customerAdmin ? <th className={classes.tableVendorName}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("vendor_name")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortVendorName(!sortVendorName)}>
                          {!sortVendorName ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th> : null}
                    {level <= roles.customerAdmin ? <th className={classes.tableJrvCode}>
                      <div className={classes.tableSubtitle}>
                        <div>
                          {I18n.get("jrv_code")}
                        </div>
                        <div className={classes.sortContainer} onClick={() => setSortJrvCode(!sortJrvCode)}>
                          {!sortJrvCode ? <img src={DropdownDown} className={classes.dropdownInverted} alt="Sort Up Arrow" /> : <img src={DropdownDown} alt="Sort Down Arrow" />}
                        </div>
                      </div>
                    </th> : null}
                  </tr>
                </thead>
                {/* TABLE BODY */}
                <tbody>
                  {searchResults.map((r, i) =>
                    <tr className={`${(i + 1) % 2 === 0 ? classes.evenRow : ""}`} onClick={() => handleLookupDialog(r.product_id, r, r.pzi_id)}>
                      {level <= roles.customerAdmin ?
                        <td className={classes.tableCompany}>
                          {r.company_name}
                        </td>
                        : null}
                      <td className={classes.tableDescription}>
                        {language === 'en' ? r.description_en : r.description_fr}
                      </td>
                      <td className={classes.tableManufacturerCode}>
                        {r.manufacturer_item_code}
                      </td>
                      <td className={classes.tablePendingOrder}>
                        <div className={`${classes.textRed}`}>
                          {r.sum_quantity > 0 ? <div><span className={classes.textBold}>{`${I18n.get("ordered_quantity")}${language === "en" ? ": " : " : "}`}</span>{r.sum_quantity}</div> : null}
                          {r.sum_remaining_quantity > 0 ? <div><span className={classes.textBold}>{`${I18n.get("replenishment_outstanding")}${language === "en" ? ": " : " : "}`}</span>{r.sum_remaining_quantity}</div> : null}
                        </div>
                      </td>
                      <td className={classes.tableSite}>
                        {r.site_name}
                      </td>
                      <td className={classes.tableSector}>
                        {r.sector_name}
                      </td>
                      <td className={classes.tableBinCode}>
                        {r.pzi_id}
                      </td>
                      <td className={classes.tableLocation}>
                        {r.assigned[0]}
                      </td>
                      <td className={`${classes.tableCategory} ${classes.cellEllipse}`} title={r.category}>
                        {r.category}
                      </td>
                      <td className={classes.tableManufacturer}>
                        {r.manufacturer_name}
                      </td>
                      {level <= roles.customerAdmin ?
                        <td className={`${classes.tableVendorName} ${classes.cellEllipse}`} title={r.vendor_name}>
                          {r.vendor_name}
                        </td>
                        : null}
                      {level <= roles.customerAdmin ?
                        <td className={classes.tableJrvCode}>
                          {r.jrv_code}
                        </td>
                        : null}
                    </tr>
                  )}
                </tbody>
              </table>
              :
              searchResults.map(r => <ProductLookupTableRow data={r} handleLookupDialog={handleLookupDialog} />)
            }
          </div>
          <div className={classes.paginationSection}>
            <div className={classes.paginationMain}>
              {getWidth() > 470 ?
                <div className={classes.paginationLimit}>
                  <div>{`${I18n.get("resultsPerPage")}${language === "en" ? ": " : " : "}`}</div>
                  <Select
                    value={searchLimit}
                    onChange={handleLimitChange}
                    className={classes.paginationDropdown}
                    disableUnderline
                  >
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                  </Select>
                </div>
                : null}
              {searchResults.length > 0 ? <div className={classes.countDisplay}>{getWidth() < 470 ? <span style={{ marginRight: "16px" }}>Page {(searchOffset / searchLimit) + 1}/{pagesQuantity}</span> : null}{`${1 + searchOffset}-${searchOffset + searchResults.length} of ${searchTotal}`}</div> : null}
              {pagesQuantity > 0 ?
                <div className={classes.pageControl}>
                  <div className={classes.offsetControl} onClick={() => handleOffset("min")}>
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.2209 7.41L12.6409 12L17.2209 16.59L15.8109 18L9.81095 12L15.8109 6L17.2209 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === 0 ? "0.2" : "1"} />
                      <rect x="8.84302" y="18" width="2" height="12" transform="rotate(-180 8.84302 18)" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === 0 ? "0.2" : "1"} />
                    </svg>
                  </div>
                  <div className={classes.offsetControl} onClick={() => handleOffset("minus")}>
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.442 7.41L10.862 12L15.442 16.59L14.032 18L8.03202 12L14.032 6L15.442 7.41Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === 0 ? "0.2" : "1"} />
                    </svg>
                  </div>
                  <div className={classes.pageDisplay}>{(searchOffset / searchLimit) + 1}</div>
                  <div className={classes.offsetControl} onClick={() => handleOffset("plus")}>
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.62195 16.59L13.2019 12L8.62195 7.41L10.0319 6L16.0319 12L10.0319 18L8.62195 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                    </svg>
                  </div>
                  <div className={classes.offsetControl} onClick={() => handleOffset("max")}>
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.84302 16.59L11.423 12L6.84302 7.41L8.25302 6L14.253 12L8.25302 18L6.84302 16.59Z" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                      <rect x="15.2209" y="6" width="2" height="12" fill={getWidth() < 470 ? "#5f00a0" : "black"} fill-opacity={searchOffset === ((pagesQuantity - 1) * searchLimit) ? "0.2" : "1"} />
                    </svg>
                  </div>
                </div>
                : null}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ProductLookup))
);
